import { render, staticRenderFns } from "./wordDetailResult.vue?vue&type=template&id=247d26a0&scoped=true&"
import script from "./wordDetailResult.vue?vue&type=script&lang=js&"
export * from "./wordDetailResult.vue?vue&type=script&lang=js&"
import style0 from "./wordDetailResult.vue?vue&type=style&index=0&id=247d26a0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247d26a0",
  null
  
)

export default component.exports